import React from 'react';
import { motion } from 'framer-motion';

const shimmer = {
  hidden: { x: '-100%' },
  visible: { 
    x: '100%',
    transition: {
      repeat: Infinity,
      duration: 1.5,
      ease: "easeInOut"
    }
  }
};

export const LoadingSkeleton: React.FC = () => {
  return (
    <div className="relative overflow-hidden">
      <div className="animate-pulse space-y-4">
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        </div>
      </div>
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
        variants={shimmer}
        initial="hidden"
        animate="visible"
      />
    </div>
  );
};

export const EventSkeleton: React.FC = () => {
  return (
    <div className="relative overflow-hidden bg-white rounded-lg shadow-md p-6">
      <div className="animate-pulse space-y-4">
        <div className="h-6 bg-gray-200 rounded w-3/4"></div>
        <div className="space-y-3">
          <div className="flex items-center">
            <div className="w-5 h-5 bg-gray-200 rounded-full mr-2"></div>
            <div className="h-4 bg-gray-200 rounded w-1/3"></div>
          </div>
          <div className="flex items-center">
            <div className="w-5 h-5 bg-gray-200 rounded-full mr-2"></div>
            <div className="h-4 bg-gray-200 rounded w-1/4"></div>
          </div>
          <div className="flex items-center">
            <div className="w-5 h-5 bg-gray-200 rounded-full mr-2"></div>
            <div className="h-4 bg-gray-200 rounded w-2/5"></div>
          </div>
        </div>
        <div className="h-20 bg-gray-200 rounded w-full"></div>
      </div>
      <motion.div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
        variants={shimmer}
        initial="hidden"
        animate="visible"
      />
    </div>
  );
};